import ApiClient from "@/client/api/ApiClient"

const baseUrl = `/api/v1`

export const api = new ApiClient(baseUrl)
export default api
